export function echartsTooltipFormatterSingle(title, color, list, customClass = 'echarts-tooltip') {
	const content = list
		.map(
			item => `
        <div class='echarts-tooltip-wrapper'>
            <div style='display: flex; align-items: center;'>
                <div class='echarts-tooltip-item-name'>${title
					? ''
					: `<span style='margin-right: 6px; width: 8px; height: 8px; border-radius: 2px; background: ${color}; display: ${color ? 'inline' : 'none'
					}'></span>`
				}<span>${item.name}</span></div>
            </div>
            <p class='echarts-tooltip-item-value'>${item.value}</p>
        </div>
    `
		)
		.join('');
	return `
        <div class='${customClass}'>
            ${title
			? `<div class='echarts-tooltip-name'>
				<span style='margin-right: 6px; width: 8px; height: 8px; border-radius: 2px; background: ${color}; display: ${color ? 'inline' : 'none'
			}'></span>
				${title}
			</div>`
			: ''
		}
			<div class='echarts-tooltip-container ${list.length > 10 ? 'echarts-tooltip-grid' : ''}'>
            	${content}
			</div>
        </div>
    `;
}

export function echartsTooltipFormatterMultiple(title, list, customClass = 'echarts-tooltip') {
	const content = list
		.map(
			item => `
        <div class='echarts-tooltip-wrapper'>
            <div style='display: flex; align-items: center;'>
                <span style='margin-right: 6px; width: 8px; height: 8px; border-radius: 2px; background: ${item.color
				}; display: ${item.color ? 'inline' : 'none'}'></span>
                <p class='echarts-tooltip-item-name'>${item.seriesName}</p>
            </div>
            <p class='echarts-tooltip-item-value'>${item.value}</p>
        </div>
    `
		)
		.join('');
	return `
        <div class='${customClass}'>
            ${title ? `<div class='echarts-tooltip-name'>${title}</div>` : ''}
			<div class='echarts-tooltip-container ${list.length > 10 ? 'echarts-tooltip-grid' : ''}'>
            	${content}
			</div>
        </div>
    `;
}

/**
 * 调整颜色值，加上一点白色，一般是 echarts 使用
 * @param {string} color 如 #eeff12
 * @param {number} amount 混合白色比例
 * @returns {string}
 */
export function transformColor(color, amount = 0.2) {
	if (!color) {
		return '';
	}
	// 将颜色转换为 RGB 值
	let r = parseInt(color.slice(1, 3), 16);
	let g = parseInt(color.slice(3, 5), 16);
	let b = parseInt(color.slice(5, 7), 16);

	// 计算加入白色后的 RGB 值
	r = Math.round((1 - amount) * r + amount * 255);
	g = Math.round((1 - amount) * g + amount * 255);
	b = Math.round((1 - amount) * b + amount * 255);

	// 将 RGB 值转换为十六进制颜色值
	color = '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0');
	return color;
}

export function flatData(list) {
	return list
		.map(ele =>
			ele.data.map(item =>
				typeof item === 'object' ? (Array.isArray(item?.value) ? item.value[1] : item?.value) : item
			)
		)
		.flat()
		.filter(ele => !['', '-', undefined, null, NaN].includes(ele));
}

// 基准大小
const baseSize = 100;
// px2rem
export function convertPX(px) {
	var fontSize = document.documentElement.style.fontSize;
	return (px / baseSize) * parseFloat(fontSize.replace('px', ''));
}
